import { connect } from "react-redux";
import App from "components/app.jsx";


const mapStateToProps = (state) => ({
    modal: state.modal,
});


export default connect(mapStateToProps, null)(App);


// WEBPACK FOOTER //
// ./src/js/containers/app.js